import {Region} from "platformed-client/types";
import api from "../../api";
import {param, typedQuery} from "../typing";

export const portalRegions = typedQuery(["portal", "regions"], async () => {
  return await api.portalDiscovery.listRegions();
});

export const portalsInRegion = typedQuery(["portal", "portals", param<Region>("region")], async region => {
  try {
    const portals = await api.portalDiscovery.listPortals(region);
    return {region, portals};
  } catch {
    return {region, portals: null};
  }
});
